/**
 * Removes a parameter from the url query
 *
 * @param {string} url - url to clean from the param
 * @param {string} paramName - name of parameter to be removed
 *
 * @returns {string}
 */
const removeQueryParam = (url, paramName) => {
	const re = new RegExp(`(?:^|&)${paramName}=[^$&]+`);
	const [path, search] = url.split("?");
	const newSearch = search.replace(re, "").replace(/^&/, "");
	return newSearch ? `${path}?${newSearch}` : path;
};

export default removeQueryParam;
